/**
 * Displays the effective label of a column selected on the report. In other words, if there is an aggregate
 * selected on the column, that aggregate is incorporated into this display.
 *
 * @param {Props} props - The props.
 * @param {FilterSelectedColumn} props.filterSelectedColumn - The FilterSelectedColumn to represent.
 */
const FilterSelectedColumnLabel = (props) => {
    var _a, _b, _c, _d;
    if (!props.filterSelectedColumn ||
        !props.filterSelectedColumn.filterSourceColumn) {
        return "";
    }
    // If there is an aggregate selected, incorporate that into the display.
    if (props.filterSelectedColumn.aggregateFunction === "Count") {
        return "Count";
    }
    let nameAndFormat = props.filterSelectedColumn.filterSourceColumn.displayName;
    if (props.filterSelectedColumn.format &&
        props.filterSelectedColumn.format !== "None") {
        nameAndFormat += ` ${props.filterSelectedColumn.format}`;
    }
    if (props.filterSelectedColumn.aggregateFunction) {
        nameAndFormat = `${props.filterSelectedColumn.aggregateFunction} of ${nameAndFormat}`;
    }
    if ((_b = (_a = props.filterSelectedColumn) === null || _a === void 0 ? void 0 : _a.filterSourceRelationship) === null || _b === void 0 ? void 0 : _b.title) {
        nameAndFormat += ` [${props.filterSelectedColumn.filterSourceRelationship.title}]`;
    }
    else {
        nameAndFormat =
            nameAndFormat +
                ` [` +
                (
                // @ts-expect-error - TS2339 - Property 'filterSource' does not exist on type 'FilterSourceColumn'.
                (_d = (_c = props.filterSelectedColumn.filterSourceColumn) === null || _c === void 0 ? void 0 : _c.filterSource) === null || _d === void 0 ? void 0 : _d.displayName) +
                `] `;
    }
    return nameAndFormat;
};
export default FilterSelectedColumnLabel;
